import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common-service';

@Injectable({
    providedIn: 'root'
})
export class CustomMatIconService {
    icons:any =[]

    constructor(
        private matIconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
        private http: HttpClient,
    ) {
        this.http.get<any>('assets/json/icons.json').subscribe((data: any) => {
            this.icons = data;
            console.log(this.icons)
            this.registerIcons();
        });
    }

    registerIcons(): void {
        const registered = new Set<string>();
        this.icons.forEach((icon:any) => {
            if (!registered.has(icon.name)) {
                this.matIconRegistry.addSvgIcon(
                    icon.name,
                    this.sanitizer.bypassSecurityTrustResourceUrl(icon.path)
                );
                registered.add(icon.name);
            }
        });
    }
}
